import { Icon, Button, Textarea } from '@sanlam-glacier/app-common/components';
import { displayToast } from '@sanlam-glacier/app-common/modules/toasts';
import { useReportForm } from 'modules/reports/hooks/useReportFormContext';

export const ReviewReport = () => {
  const { formData, updateFormData } = useReportForm();

  const handleSubmit = () => {
    displayToast({
      toastId: 'user-info-jwt-token-copy',
      title: 'Successfully submitted report',
      message: `Submitting the following - ${JSON.stringify(formData, null, 2)}`,
      status: 'info'
    });
  };

  const handleNotesChange = (value: string) => {
    updateFormData({ notes: value });
  };

  return (
    <div>
      <h2>Review Report</h2>

      <div style={{ margin: '1rem 0' }}>
        <label htmlFor='notes'>Notes (optional):</label>
        <Textarea id='notes' value={formData.notes} onChange={handleNotesChange} rows={4} />
      </div>

      <Button
        onClick={handleSubmit}
        size={Button.SIZE.SMALL}
        startIcon={<Icon icon='content_add' />}
        style={{ marginLeft: 'auto' }}
      >
        Submit Report
      </Button>
    </div>
  );
};
